import { render, staticRenderFns } from "./FeedListItemSkeleton.vue?vue&type=template&id=1c32f901&scoped=true"
import script from "./FeedListItemSkeleton.vue?vue&type=script&lang=ts"
export * from "./FeedListItemSkeleton.vue?vue&type=script&lang=ts"
import style0 from "./FeedListItemSkeleton.vue?vue&type=style&index=0&id=1c32f901&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c32f901",
  null
  
)

export default component.exports